import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Trimester } from '@interfaces';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<Trimester, unknown>[] = [
		buildColumn(util, 'Id', row => row.trimesterId),
		buildColumn(util, 'Text', row => row.name, { header: 'Name', width: 70 }),
		buildColumn(util, 'Text', row => row.year.toString(), { header: 'Year', width: 60 }),
		buildColumn(util, 'Number', row => parseInt(row.trimesterIndex, 10), { header: 'T#', width: 50 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.applicationDeadlineUTC), { header: 'Entrepreneur Submission Deadline' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.mentorSignupDeadlineUTC), { header: 'Mentor Sign-up Deadline' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.admissionsEndUTC), { header: 'Admissions End Date' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.programmingStartUTC), { header: 'Programming Start Date' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.classesStartWeekUTC), { header: 'Classes Start Week' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.classesEndUTC), { header: 'Classes End Week' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Last Updated', hidden: true }),
	];

	return columns;

}